import { select } from "redux-saga/effects";

import { IKeyValue, stringifyQueryParams } from "helpers/url";
import { sortRanking } from "routes/reports/helpers";
import { IAgent, selectAgents } from "store/entities/agents";
import { KeyMap } from "utils/interface";

import { IRanking } from "../interfaces";

interface IOptions {
  dateFrom: string;
  dateTo: string;
  tag: string[];
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function* rankingDeserializer(data: any, options: IOptions): any {
  const agents = (yield select(selectAgents)) as KeyMap<IAgent>;
  const ranking: IRanking[] = [];
  // Parse agents ranking
  Object.keys(data).forEach(agentId => {
    const { bad, neutral, good } = data[agentId];
    const total = bad + neutral + good;
    const agent = agents[agentId];
    const seeMoreRoot = "/tickets/search";
    const seeMoreDefaultQuery: IKeyValue<string> = {
      tag: options.tag,
    };
    let seeMoreUrl = "";
    let seeMoreRatedGreatUrl = "";
    let seeMoreRatedOkayUrl = "";
    let seeMoreRatedBadUrl = "";
    let seeMoreTitle = "";
    let seeMoreRatedGreatTitle = "";
    let seeMoreRatedOkayTitle = "";
    let seeMoreRatedBadTitle = "";

    seeMoreDefaultQuery.rate_date_from = options.dateFrom;
    seeMoreDefaultQuery.rate_date_to = options.dateTo;

    seeMoreTitle = `View tickets assigned to ${agent?.name}`;
    seeMoreRatedGreatTitle = `View tickets assigned to ${agent?.name} and rated great`;
    seeMoreRatedOkayTitle = `View tickets assigned to ${agent?.name} and rated great`;
    seeMoreRatedBadTitle = `View tickets assigned to ${agent?.name} and rated bad`;
    seeMoreUrl = `${seeMoreRoot}?${stringifyQueryParams({
      ...seeMoreDefaultQuery,
      // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'ParamValue ... Remove this comment to see the full error message
      assignee: name,
      rate: "rated",
    })}`;

    seeMoreRatedGreatUrl = `${seeMoreRoot}?${stringifyQueryParams({
      ...seeMoreDefaultQuery,
      // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'ParamValue ... Remove this comment to see the full error message
      assignee: name,
      rate: "rated_good",
    })}`;

    seeMoreRatedOkayUrl = `${seeMoreRoot}?${stringifyQueryParams({
      ...seeMoreDefaultQuery,
      // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'ParamValue ... Remove this comment to see the full error message
      assignee: name,
      rate: "rated_okay",
    })}`;

    seeMoreRatedBadUrl = `${seeMoreRoot}?${stringifyQueryParams({
      ...seeMoreDefaultQuery,
      // @ts-expect-error TS(2322): Type 'void' is not assignable to type 'ParamValue ... Remove this comment to see the full error message
      assignee: name,
      rate: "rated_bad",
    })}`;

    ranking.push({
      id: agent?.id,
      email: agent?.email,
      name: agent?.name,
      removed: !agent,
      // @ts-expect-error TS(2322)
      photoUrl: agent?.avatar,
      seeMoreUrl,
      seeMoreTitle,
      seeMoreRatedGreatUrl,
      seeMoreRatedGreatTitle,
      seeMoreRatedOkayUrl,
      seeMoreRatedOkayTitle,
      seeMoreRatedBadUrl,
      seeMoreRatedBadTitle,
      total: total as number,
      ratedGreatCount: good as number,
      ratedGreatPercentage: Math.round((good / total) * 100),
      ratedOkayCount: neutral as number,
      ratedOkayPercentage: Math.round((neutral / total) * 100),
      ratedBadCount: bad as number,
      ratedBadPercentage: Math.round((bad / total) * 100),
    });
  });

  return ranking.sort(sortRanking);
}
